<div *ngIf="hasUser()" class="result">

    <!-- User Info -->
    <div class="user-info section">
        <div class="title">User</div>
        <div>{{ login() }}</div>
        <div *ngIf="iid() as userIid" class="user-actions">
            <a class="account-snapshot-btn" [href]="'/rest/admin/download_snapshot/' + userIid" download>
                <span class="account-snapshot-icon" aria-hidden="true">↓</span>
                <span>Account snapshot</span>
            </a>
        </div>
    </div>

    <div class="section" *ngIf="user()">
        <license-info [iid]="user()!.iid"/>
    </div>

    <!-- Tabs Navigation -->
    <div class="tabs-container">
        <div class="tab-buttons">
            <button
                    [class.active]="selectedTab == Tab.Installs"
                    (click)=selectTab(Tab.Installs)>
                Installs
            </button>
            <button
                    [class.active]="selectedTab == Tab.Rounds"
                    (click)=selectTab(Tab.Rounds)>
                Rounds
            </button>

            <button
                    [class.active]="selectedTab == Tab.Properties"
                    (click)=selectTab(Tab.Properties)>
                Properties
            </button>
        </div>

        <!-- Tab Content -->
        <div class="tab-content">

            <!-- Installs Tab -->
            <div *ngIf="selectedTab == Tab.Installs" class="section installs">
                <div class="title">Installs</div>
                <table>
                    <tr>
                        <th>Install Id</th>
                        <th>Rounds</th>
                        <th>Creation date</th>
                        <th>Client info</th>
                    </tr>
                    <tr *ngFor="let install of installs()">
                        <td>{{ install.iid }}</td>
                        <td>{{ install.roundsCount }}</td>
                        <td>{{ install.timestamp | date: 'dd MMM yyyy' : 'UTC' }}</td>
                        <td>
                            <span [hidden]="!install.deviceModel">Device: {{ install.deviceModel }}</span><br/>
                            <span [hidden]="!install.appVersion">App: {{ install.appVersion }}</span><br/>
                            <span [hidden]="install.pairedWatchesInfo?.deviceModel == null">
                Watch: {{ install.pairedWatchesInfo?.deviceModel }}
              </span><br/>
                            <span [hidden]="install.pairedWatchesInfo?.osVersion == null">
                OS Watch: {{ install.pairedWatchesInfo?.osVersion }}
              </span><br/>
                            <span [hidden]="install.pairedWatchesInfo?.appVersion == null">
                Watch app: {{ install.pairedWatchesInfo?.appVersion }}
              </span>
                        </td>
                    </tr>
                </table>
            </div>

            <!-- Rounds Tab -->
            <div *ngIf="selectedTab == Tab.Rounds" class="section rounds">
                <app-alert *ngIf="rounds().length > 0"/>
                <div class="title">Rounds</div>

                <div *ngIf="rounds().length > 0; else noRounds">
                    <table>
                        <tr>
                            <th>Round Token</th>
                            <th>Install Id</th>
                            <th>Date</th>
                            <th>Link</th>
                            <th>Download</th>
                            <th>Delete / Undelete</th>
                            <th>Print</th>
                        </tr>
                        <tr *ngFor="let round of rounds()" [class.deleted-round]="round.isDeleted">
                            <td>{{ round.token }}</td>
                            <td>{{ round.iid }}</td>
                            <td>{{ round.timestamp | date: 'dd MMM yyyy' : 'UTC' }}</td>
                            <td><a routerLink="/round/{{round.token}}">Open</a></td>
                            <td><a [href]="'/rest/admin/download_round/' + round.token" download>Download</a></td>
                            <td>
                                <a href="#" (click)="handleDeleteOrUndelete($event, round.isDeleted, round.token)">
                                    {{ round.isDeleted ? 'Undelete' : 'Delete' }}
                                </a>
                            </td>
                            <td><a [href]="'/rest/admin/round?token=' + round.token" target="_blank">Show</a></td>
                        </tr>
                    </table>
                </div>

                <ng-template #noRounds>
                    <p>No rounds available.</p>
                </ng-template>
            </div>

            <!-- Installs Tab -->
            <div *ngIf="selectedTab == Tab.Properties" class="section properties">
                <div class="title">Properties</div>
                <add-server-property [iid]="user()!.iid" />
                <div class="properties-list">
                    <div *ngFor="let prop of properties()"
                         class="property-card"
                         [class.deleted]="prop.isDeleted">

                        <!-- Default -->
                        <div *ngIf="prop | PropertyType:'Default' as defaultType" class="contact-model">
                            <h4>{{ defaultType.key }}</h4>
                        </div>
                        <!-- Contact -->
                        <div *ngIf="prop | PropertyType:'Contact' as contact" class="contact-model">
                            <h4>Contact</h4>
                            <p><strong>Name:</strong> {{ contact.name }}</p>
                            <p><strong>Email:</strong> <a href="mailto:{{ contact.email }}">{{ contact.email }}</a></p>
                        </div>

                        <!-- License -->
                        <div *ngIf="prop | PropertyType:'License' as license" class="license">
                            <h4>License</h4>
                            <p><strong>Value:</strong> <code>{{ license.value }}</code></p>
                        </div>

                        <!-- ClientInstallReferrer -->
                        <div *ngIf="prop | PropertyType:'ClientInstallReferrer' as clientInstallReferrer"
                             class="client-install-referrer">
                            <h4>Client Install Referrer</h4>
                            <p><strong>Referrer:</strong> {{ clientInstallReferrer.referrer }}</p>
                            <p><strong>Version:</strong> {{ clientInstallReferrer.installVersion }}</p>
                            <p><strong>Date:</strong> {{ clientInstallReferrer.date | date:'dd MMM yyyy HH:mm' : 'UTC' }}</p>
                        </div>

                        <!-- Club -->
                        <div *ngIf="prop | PropertyType:'Club' as club" class="club">
                            <h4>Club</h4>
                            <p><strong>ID:</strong> {{ club.id }}</p>
                            <p><strong>NFC ID:</strong> {{ club.nfcId }}</p>
                            <p><strong>Type:</strong> {{ club.clubType }}</p>
                            <p><strong>In Bag:</strong> {{ club.isInBag ? 'Yes' : 'No' }}</p>
                            <p *ngIf="club.isClubDeleted" class="warning">⚠️ This club is marked as deleted.</p>
                        </div>

                        <!-- ClubList -->
                        <div *ngIf="prop | PropertyType:'ClubList' as clubList" class="club-list">
                            <h4>Club List ({{ clubList.clubs.length }} clubs)</h4>
                            <table class="sub-table">
                                <tr>
                                    <th>ID</th>
                                    <th>NFC</th>
                                    <th>Type</th>
                                    <th>In Bag</th>
                                    <th>Status</th>
                                </tr>
                                <tr *ngFor="let club of clubList.clubs" [class.deleted]="club.isClubDeleted || club.isDeleted">
                                    <td>{{ club.id }}</td>
                                    <td>{{ club.nfcId }}</td>
                                    <td>{{ club.clubType }}</td>
                                    <td>{{ club.isInBag ? '✅' : '❌' }}</td>
                                    <td>
                                        <span *ngIf="club.isClubDeleted || club.isDeleted" class="status deleted-status">Deleted</span>
                                        <span *ngIf="!(club.isClubDeleted || club.isDeleted)" class="status active-status">Active</span>
                                    </td>
                                </tr>
                            </table>
                        </div>

                        <!-- Common footer -->
                        <div class="meta-info">
                            <small>Updated: {{ prop.commitTs | date:'dd MMM yyyy HH:mm:ss' : 'UTC' }}, ({{ prop.commitTs }})</small>
                            <span *ngIf="prop.isDeleted" class="deleted-badge">DELETED</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>